import { tw } from 'utils/classnames'

import { Typography } from '../typography'

interface CardTitleProps {
  children: React.ReactNode
  className?: string
}

export const CardTitle = (props: CardTitleProps) => {
  return (
    <Typography variant="heading-4" className={tw(props.className)} asChild>
      <h3>{props.children}</h3>
    </Typography>
  )
}
